import React, { useRef } from "react";
import { SkipLinkIdentifier, SkipLinkModel } from "./tools/SkipLink.const";
import { useSkipLink } from "./tools/useSkipLink";
import { SkipLinkAnchor } from "./components/SkipLinkAnchor";
import { useSkipLinkReferer } from "./tools/useSkipLinkReferer";

import useStyles from "./SkipLink.style";

const SkipLink = ({
  isScreenReaderVisibilityEnabled = false,
  skipToMainLinkLabel,
  skipToSidebarNavigationLinkLabel,
}: SkipLinkModel) => {
  const { handleSkipToMainContent, handleSkipToSidebarNavigation, mainRef, sidebarNavigationRef } =
    useSkipLink();
  const c = useStyles({ isScreenReaderVisibilityEnabled });
  const ref = useRef<HTMLDivElement | null>(null);
  const mainRefererExists = useSkipLinkReferer(mainRef);
  const sidebarNavigationRefererExists = useSkipLinkReferer(sidebarNavigationRef);

  return (
    <div ref={ref} tabIndex={-1} className={c.wrapper}>
      {mainRefererExists && <SkipLinkAnchor
        href={`#${SkipLinkIdentifier.MAIN}`}
        label={skipToMainLinkLabel}
        onClick={handleSkipToMainContent}
        isScreenReaderVisibilityEnabled={isScreenReaderVisibilityEnabled}
      />}
      {sidebarNavigationRefererExists && skipToSidebarNavigationLinkLabel && (
        <SkipLinkAnchor
          href={`#${SkipLinkIdentifier.SIDEBAR_NAVIGATION}`}
          label={skipToSidebarNavigationLinkLabel}
          onClick={handleSkipToSidebarNavigation}
          isScreenReaderVisibilityEnabled={isScreenReaderVisibilityEnabled}
        />
      )}
    </div>
  );
};

export { SkipLink };
